//components
import { BasicBreadcrumbs, BasicButton, LoadingSpinner, SimpleSearchInput, SimpleTable } from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import SimpleBar from 'simplebar-react';
import RequestMessagePanel from  '@/components/elements/passkeys/RequestMessage/requestMessagePanel';

//hooks and helpers
import UseRecoveryRequestsModal from './RecoveryRequestsModal.hooks';
import { simpleBarAutoScrollHandler } from  '@/helpers/SimpleBar';

import "../../../../../css/global/Modals/recovery-requests-modal.scss";



const RecoveryRequestsModal = ({showModal, hideModal} : {showModal: boolean, hideModal: () => void}) => {
    const {
        simpleBarRef, 
        breadcrumbs,
        searchTerm,
        isGettingLocation,
        location,
        notificationDetails,
        requestsForIpTableContent,
        tableContent,
        tableHeight,
        autoScrollHandler,
        displayMessage,
        ipAddress,
        setDisplayMessage,
        getMoreData,
        onGetLocationClick,
        setSearchTerm,
    } = UseRecoveryRequestsModal({showModal});

    return (
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="recovery-requests-modal" 
            isFullPage
        >
                <div className="recovery-requests-modal-content">
                    <h1 className='header-text'>Account Recovery Requests</h1> 

                    <BasicBreadcrumbs 
                        breadCrumbs={breadcrumbs}
                    />
                    
                    <div className='recovery-request-panel thrive-red-info-panel'>
                        Recovery requests might not be legitimate. Make sure you verify the user’s identity yourself before taking any action.
                    </div>

                    {displayMessage 
                        ?   <RequestMessagePanel
                                request={displayMessage} 
                                onClearMessage={()=>setDisplayMessage(undefined)}
                            />

                        :   <>
                            <div className='search-panel'>
                                <SimpleSearchInput 
                                    ariaLabel={'Search for recovery request data'} 
                                    setSearchString={setSearchTerm} 
                                    searchString={searchTerm}     
                                />
                            </div>
                        
                            <SimpleBar 
                                className='recovery-requests-simple-bar' 
                                style={{ height: tableHeight }} 
                                scrollableNodeProps={{  
                                    ref: simpleBarRef, 
                                    onScroll: (e: React.UIEvent<HTMLElement>) => simpleBarAutoScrollHandler(e, autoScrollHandler, getMoreData) 
                                }}
                                >
                                    {
                                        <SimpleTable 
                                            key={ipAddress ? 1 : 2}
                                            {...(ipAddress ? requestsForIpTableContent : tableContent)}
                                        />
                                    }
                            </SimpleBar>  
                            </>
                    }
                                     
                    <div className='modal-panel'>
                        {ipAddress &&
                            (location
                                ?   <span className='geo-location'>{location}</span>
                                :   <BasicButton
                                        content={isGettingLocation ? <LoadingSpinner size={10} /> : "Get Approximate Location"}  
                                        className={isGettingLocation ? "location-button-loading" :"location-button"}  
                                        ariaLabel={'Get Approximate Location'} 
                                        onButtonClick={onGetLocationClick}
                                    />
                            )
                        }

                        <BasicButton 
                            content={"Close"}  
                            className={"close-button"}  
                            ariaLabel={'Close Modal'} 
                            onButtonClick={hideModal}
                        />
                    </div>
                </div>

                {notificationDetails &&
                    <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
                }
        </ModalWrapper> 
    );  
}

export default RecoveryRequestsModal;
